/**
 * Date-extensions locale French (Switzerland) [fr-ch]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('fr-ch', {
    monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
    monthShortNames: ['Janv.','Févr.','Mars','Avr.','Mai','Juin','Juil.','Août','Sept.','Oct.','Nov.','Déc.'],
    dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
    dayShortNames: ['Dim.','Lun.','Mar.','Mer.','Jeu.','Ven.','Sam.']
});
